// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExpressContactSaveDto
 */
export interface IExpressContactSaveDto {
    /**
     * 
     * @type {number}
     * @memberof IExpressContactSaveDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IExpressContactSaveDto
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressContactSaveDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressContactSaveDto
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressContactSaveDto
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressContactSaveDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressContactSaveDto
     */
    phone?: string;
    /**
     * 
     * @type {number}
     * @memberof IExpressContactSaveDto
     */
    distributor_id: number;
}

/**
 * Check if a given object implements the IExpressContactSaveDto interface.
 */
export function instanceOfIExpressContactSaveDto(value: object): value is IExpressContactSaveDto {
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('distributor_id' in value) || value['distributor_id'] === undefined) return false;
    return true;
}

export function IExpressContactSaveDtoFromJSON(json: any): IExpressContactSaveDto {
    return IExpressContactSaveDtoFromJSONTyped(json, false);
}

export function IExpressContactSaveDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressContactSaveDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'username': json['username'] == null ? undefined : json['username'],
        'password': json['password'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'distributor_id': json['distributor_id'],
    };
}

export function IExpressContactSaveDtoToJSON(json: any): IExpressContactSaveDto {
    return IExpressContactSaveDtoToJSONTyped(json, false);
}

export function IExpressContactSaveDtoToJSONTyped(value?: IExpressContactSaveDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'username': value['username'],
        'password': value['password'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'email': value['email'],
        'phone': value['phone'],
        'distributor_id': value['distributor_id'],
    };
}

